import { getCurrentPcOrgs } from '@/api';
import Cookies from 'js-cookie'

const state = {
  accessToken: null, // 用户token
  userId: null, // 用户id
  userName: null, // 姓名
  loginName: null, // 登陆用户名
  photoPath: null, // 头像地址
  orgId: null, // 当前企业id
  isSys: null, // 当前是否为平台管理员
  isOrgSuper: null, // 是否企业超管
  organizations: [] // 用户机构列表（包括平台按理）
}
const getters = {
  accessToken: state => state.accessToken,
  userId: state => state.userId,
  userName: state => state.userName,
  loginName: state => state.loginName,
  photoPath: state => state.photoPath,
  orgId: state => state.orgId,
  isSys: state => state.isSys,
  isOrgSuper: state => state.isOrgSuper,
  organizations: state => state.organizations
}
const mutations = {
  setAccessToken: (state, accessToken) => state.accessToken = accessToken,
  setUserId: (state, userId) => state.userId = userId,
  setUserName: (state, userName) => state.userName = userName,
  setLoginName: (state, loginName) => state.loginName = loginName,
  setPhotoPath: (state, photoPath) => state.photoPath = photoPath,
  setOrgId: (state, orgId) => state.orgId = orgId,
  setIsSys: (state, isSys) => state.isSys = isSys,
  setIsOrgSuper: (state, isOrgSuper) => state.isOrgSuper = isOrgSuper,
  setOrganizations: (state, organizations) => state.organizations = organizations,
  removeToken(state) {
    state.accessToken = null;
    state.userId = null;
    state.userName = null;
    state.loginName = null;
    state.photoPath = null;
    state.orgId = null;
    state.isSys = null;
    state.isOrgSuper = null;
    state.organizations = null;
    Cookies.remove('accessToken');
    Cookies.remove('userId');
    Cookies.remove('userName');
    Cookies.remove('loginName');
    Cookies.remove('photoPath');
    Cookies.remove('orgId');
    Cookies.remove('isSys');
    Cookies.remove('isOrgSuper');
  },
  checkToken(state) {
    if (!state.accessToken) {
      let accessToken = Cookies.get('accessToken');
      let userId = Cookies.get('userId');
      let userName = Cookies.get('userName');
      let loginName = Cookies.get('loginName');
      let photoPath = Cookies.get('photoPath');
      let orgId = Cookies.get('orgId');
      let isSys = Cookies.get('isSys');
      let isOrgSuper = Cookies.get('isOrgSuper');
      this.commit('setAccessToken', accessToken === 'null' ? null : accessToken);
      this.commit('setUserId', userId === 'null' ? null : userId);
      this.commit('setUserName', userName === 'null' ? null : userName);
      this.commit('setLoginName', loginName === 'null' ? null : loginName);
      this.commit('setPhotoPath', photoPath === 'null' ? null : photoPath);
      this.commit('setOrgId', orgId === 'null' ? null : orgId);
      this.commit('setIsSys', isSys === 'null' ? null : isSys === 'true');
      this.commit('setIsOrgSuper', isOrgSuper === 'null' ? null : isOrgSuper === 'true');
    }
  },
  setUserInfo: (state, {user, organizations, token}) => {

    Cookies.set('accessToken', token);
    Cookies.set('userId', user.id);
    Cookies.set('userName', user.name);
    Cookies.set('loginName', user.loginName);
    Cookies.set('photoPath', user.photoPath);
    Cookies.set('orgId', user.orgId);
    Cookies.set('isSys', user.isSys);
    Cookies.set('isOrgSuper', user.isOrgSuper);

    state.accessToken = token;
    state.userId = user.id;
    state.userName = user.name;
    state.loginName = user.loginName;
    state.photoPath = user.photoPath;
    state.orgId = user.orgId;
    state.isSys = user.isSys;
    state.isOrgSuper = user.isOrgSuper;

    state.organizations = organizations|| []
  },
  switchOrgSetUser: (state, user) => {
    Cookies.set('orgId', user.orgId);
    Cookies.set('isSys', user.isSys);
    Cookies.set('isOrgSuper', user.isOrgSuper);
    
    state.orgId = user.orgId;
    state.isSys = user.isSys;
    state.isOrgSuper = user.isOrgSuper;
  }
}
const actions = {
  checkOrgnizations:  ({ commit, getters }) => {
    if (getters.organizations && getters.organizations.length) {
      return;
    }
    getCurrentPcOrgs().then(({data}) => {
      commit('setOrganizations', data.data)
    })
  }
};
export default { state, getters, mutations, actions }
